import styles from './IntroModal.module.css';
import useIntroModal from '../hooks/useIntroModal.js';

function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * [모듈 5] 인트로 영상 팝업. 스타일+마크업+훅이 자체 완결로 묶여 있던 원본 </body> 직전
 * 블록을 그대로 컴포넌트로 옮겼다. 자동 오픈/세션 플래그/음소거 해제 등 동작은
 * hooks/useIntroModal.js 참고.
 */
export default function IntroModal() {
  const { videoRef, isOpen, isMuted, showFab, closeModal, openModal, handleUnmute } = useIntroModal();

  return (
    <>
      <div
        className={cx(styles.introModalBackdrop, isOpen && styles.open)}
        aria-hidden={!isOpen}
        onClick={(e) => {
          if (e.target === e.currentTarget) closeModal();
        }}
      >
        <div className={styles.introModal} role="dialog" aria-label="잉글리시팝 인트로 영상">
          <div className={styles.introModalHead}>
            <span className={styles.imTitle}>
              <img src="/assets/logo_en_cut.png" alt="English POP" />
            </span>
            <button type="button" className={styles.introModalClose} aria-label="닫기" onClick={closeModal}>
              ✕
            </button>
          </div>
          <div className={styles.introVideoWrap}>
            <video ref={videoRef} src="/assets/englishpop_intro.mp4" muted playsInline controls preload="metadata"></video>
            <button
              type="button"
              className={cx(styles.introUnmute, !isMuted && styles.hidden)}
              aria-label="소리 켜고 보기"
              onClick={handleUnmute}
            >
              🔊 소리 켜고 보기
            </button>
          </div>
        </div>
      </div>
      <button
        type="button"
        className={cx(styles.introFab, !showFab && styles.hidden)}
        aria-label="인트로 영상 다시 보기"
        onClick={openModal}
      >
        <span className={styles.tri}></span> 인트로 영상
      </button>
    </>
  );
}
